const OFFSET_BEARING_ISO = /^\d{4}-\d{2}-\d{2}[Tt]\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:[Zz]|[+-]\d{2}:?\d{2})$/;
export function isOffsetBearingIso(value) {
    return typeof value === 'string' && OFFSET_BEARING_ISO.test(value.trim());
}
const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/;
export function isCalendarDate(value) {
    if (typeof value !== 'string' || !CALENDAR_DATE.test(value.trim()))
        return false;
    const [year, month, day] = value.trim().split('-').map(Number);
    if (month === undefined || day === undefined || year === undefined)
        return false;
    if (month < 1 || month > 12 || day < 1 || day > 31)
        return false;
    const probe = new Date(Date.UTC(year, month - 1, day));
    return probe.getUTCMonth() === month - 1 && probe.getUTCDate() === day;
}
export function isValidTimeZone(timeZone) {
    if (typeof timeZone !== 'string' || timeZone.length === 0)
        return false;
    try {
        new Intl.DateTimeFormat('en-US', { timeZone }).format(0);
        return true;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=validation.js.map